import React, { useState } from 'react';
import styles from './S3.module.css';
import Video1 from './videos/Calificacion.mp4'; 
import Video2 from './videos/Consistencia.mp4';
import Video3 from './videos/Tiempo.mp4';
import Video4 from './videos/Personalizacion.mp4';
import Video5 from './videos/Eficiencia.mp4'; 
import Video6 from './videos/Sesgos.mp4';
import Logo from './images/LogoCabezaBlancoSinFondo(48px).png';

const Seccion3 = () => {
  const [hoveredCard, setHoveredCard] = useState(null);

  const handleMouseEnter = (index) => {
    setHoveredCard(index);
  };

  const handleMouseLeave = () => {
    setHoveredCard(null);
  };

  const videos = [
    { src: Video1, title: "Calificación Objetiva" },
    { src: Video2, title: "Consistencia" },
    { src: Video3, title: "Ahorro de tiempo" },
    { src: Video4, title: "Hiper-personalización" },
    { src: Video5, title: "Eficiencia" },
    { src: Video6, title: "Reducción de sesgos" },
  ];

  return (
    <div className={styles.outerContainer}>
      <h1 className={styles.heading}>Beneficios</h1>
      <div className={styles.cardContainer}>
        {videos.map((video, index) => (
          <div
            key={index}
            className={`${styles.card} ${hoveredCard === index ? styles.active : ''}`}
            onMouseEnter={() => handleMouseEnter(index)}
            onMouseLeave={handleMouseLeave}
          >
            <video 
              src={video.src} 
              autoPlay 
              loop 
              playsInline
              muted
              className={styles.background} 
            />
            <div className={styles.cardContent}>
              <div className={styles.profileImage}>
                <img src={Logo} alt="Logo" />
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10"></circle>
                </svg>
              </div>
              <h3 className={styles.title}>{video.title}</h3>
            </div>
            <div className={styles.backdrop}></div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Seccion3;